module.exports = __webpack_public_path__ + "img/menu-hair-7.e2134ac7.jpg";